import * as types from "../constants/actionTypes";

export const portalInitialState = {
    roomStatuses: [],
    consumerJWT: null,
    providerJWT: null,
    consumerJWTPending: false,
    providerJWTPending: false,
    consumerJWTFailure: false,
    providerJWTFailure: false
};

export default function portalReducer(state = portalInitialState, action) {
    switch (action.type) {
        case types.GET_ROOM_STATUSES_SUCCESS:
            return { ...state, roomStatuses: action.statuses.statuses };

        case types.GET_PROVIDER_JWT_PENDING:
            return { ...state, providerJWTPending: true, consumerJWTFailure: false };
        case types.GET_PROVIDER_JWT_SUCCESS:
            return { ...state, providerJWT: action.providerToken, providerJWTPending: false, providerJWTFailure: false };
        case types.GET_PROVIDER_JWT_FAILURE:
            return { ...state, providerJWTPending: false, providerJWTFailure: true };

        case types.EMPLOYEE_TYPES:
            return { ...state, employeeTypes: action.data };
        case types.ROOM_STATUSES:
            return { ...state, roomStatuses: action.statuses };

        case types.LOGOUT:
            return portalInitialState;
        default:
            return { ...state };
    }
}